@if (!habilitaAsegurado) {
  <div class="row m-0 p-1">
    <div class="col-md-12  d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="creaPagoRecuperacion()" [disabled]="false">
        <i class="fas fa-plus"></i>&nbsp;Nuevo
      </button>
    </div>
    <div class="col-md-12 my-4 overflow-auto">
      <table mat-table multiTemplateDataRows [dataSource]="datosPagosRecuperaciones.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
        class="table d-xl-table d-md-table d-table  table-responsive my-2">
        <ng-container matColumnDef="TipoTercero">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Tipo tercero</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_tipo_tercero}}</td>
        </ng-container>
        <ng-container matColumnDef="Tipo">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_tipo_pago}}</td>
        </ng-container>
        <ng-container matColumnDef="Vehiculo">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Vehiculo</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.vehiculo}}</td>
        </ng-container>
        <ng-container matColumnDef="Compañia">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Compañia</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_cia_aseg}}</td>
        </ng-container>
        <ng-container matColumnDef="Importe">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Importe</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.importe}}</td>
        </ng-container>
        <ng-container matColumnDef="Acciones">
          <th mat-header-cell class="px-2" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="mx-1">
            <div class="row justify-content-center">
              <div class="col-md-auto">
                <button color="primary" mat-raised-button type="button"
                  (click)="abrirSeccionPagoRecuperacion(element)" [disabled]="false">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
              <div class="col-md-auto">
                <button color="warn" mat-raised-button type="button"
                  (click)="confirmaEliminacionPagoRecuperacion(element)" [disabled]="false">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- Sin resultados -->
        <ng-container matColumnDef="noData">
          <td mat-footer-cell *matFooterCellDef colspan="6">
            <small>No se encontró ningún resultado</small>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"> </tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="(datosPagosRecuperaciones?.data?.length === 0) ? '':'ocultarPaginator'">
        </tr>
      </table>
      <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
        [style.visibility]="datosPagosRecuperaciones?.data?.length >= 6 ? 'visible' : 'hidden'"
        [showFisrtLastButton]="true" [registerPerPage]="5" [totalLength]="datosPagosRecuperaciones?.data?.length">
      </app-pagina-datos-tabla>
    </div>
  </div>
}

@if (habilitaAsegurado) {
  <form [formGroup]="formPagos" class="row m-0 p-4">
    <div class="col-md-4 d-flex align-items-center gap-1">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Tipo tercero:</mat-label>
        <input matInput formControlName="descripcionTercero" placeholder="Seleccione un tercero">
      </mat-form-field>
      <button style="margin-top:-20px" mat-mini-fab color="accent" (click)="abrirModalTiposTerceros()">
        <mat-icon>search</mat-icon>
      </button>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Cobertura {{this.seccion == 1 ? 'asegurado' : 'tercero'}}:</mat-label>
        <input matInput formControlName="coberturaTercero" placeholder="Seleccione una cobertura">
        <mat-error>Campo obligatorio</mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Tipo:</mat-label>
        <mat-select formControlName="tipo" placeholder="Seleccione un tipo">
          @for (tipo of catTipos; track tipo) {
            <mat-option [value]="tipo.valor_dato">{{ tipo.descripl_dato
            }}</mat-option>
          }
        </mat-select>
        <mat-error>Campo obligatorio</mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-4"></div>
    @if ([5, 7].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Folio:</mat-label>
          <input matInput formControlName="folio" type="text" maxlength="10">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if (![5, 7].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4"></div>
    }
    @if ([5, 6, 10].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>SubTipo:</mat-label>
          <mat-select formControlName="subTipo" placeholder="Seleccione un subtipo">
            @for (sub of catSubtipos; track sub) {
              <mat-option [value]="sub.valor_dato">
                {{ sub.descripl_dato }}
              </mat-option>
            }
          </mat-select>
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if ([5, 6, 10].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4"></div>
    }
    @if ([5].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4"></div>
    }
    @if ([11].includes(this.formPagos.get('tipo')?.value) && !this.formPagos.get('subTipo')?.value) {
      <div class="col-md-4"
        >
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Importe:</mat-label>
          <input matInput formControlName="importe" type="text" formatoMoneda tipoFormato="moneda" maxlength="15">
          @if (this.formPagos.get('importe').hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
          }
          @if (this.formPagos.get('importe').hasError('importeInvalido')) {
            <mat-error>Importe mayor a
            cero</mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if ([5,6,10,11].includes(this.formPagos.get('tipo')?.value) && this.formPagos.get('subTipo')?.value) {
      <div class="col-md-4"
        >
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Importe:</mat-label>
          <input matInput formControlName="importe" type="text" formatoMoneda tipoFormato="moneda" maxlength="15">
          @if (this.formPagos.get('importe').hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
          }
          @if (this.formPagos.get('importe').hasError('importeInvalido')) {
            <mat-error>Importe mayor a
            cero</mat-error>
          }
        </mat-form-field>
      </div>
    }
    @if ([10].includes(this.formPagos.get('tipo')?.value) && this.formPagos.get('subTipo')?.value == 3) {
      <div class="col-md-6 d-flex align-items-center gap-1"
        >
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Lesionado:</mat-label>
          <input matInput formControlName="lesionado">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
        <button mat-mini-fab color="accent" (click)="abrirModalLesionados()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    }
    @if ([10].includes(this.formPagos.get('tipo')?.value) && this.formPagos.get('subTipo')?.value == 3) {
      <div class="col-md-6"
      ></div>
    }
    @if ([6].includes(this.formPagos.get('tipo')?.value) && this.formPagos.get('subTipo')?.value == 3) {
      <div class="col-md-4 mt-2">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Nombre lesionado:</mat-label>
          <input matInput placeholder="Nombre" formControlName="nombreLesionado" [UpperCase]="true">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4 mt-2">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>A. Paterno</mat-label>
          <input matInput placeholder="A. Paterno" formControlName="apellidoPaterno" [UpperCase]="true">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4 mt-2">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>A. Materno</mat-label>
          <input matInput placeholder="A. Materno" formControlName="apellidoMaterno" [UpperCase]="true">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Edad:</mat-label>
          <input matInput formControlName="edad" type="text" [OnlyNumber]="true" maxlength="3">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if (seccion == 1 && [5, 6].includes(this.formPagos.get('tipo')?.value) && (this.formPagos.get('subTipo')?.value == 3 || this.formPagos.get('subTipo')?.value == 4 )) {
      <div class="col-md-12 mt-2"
        >
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Compañía:</mat-label>
          @if (!validaCompaniaInmueble(this.detalleRecuperacionPago.cve_cobertura || 0, this.detalleRecuperacionPago.estatus_tercero, this.detalleRecuperacionPago.tipo_tercero)) {
            <input
              matInput formControlName="descripcionCompania" [UpperCase]="true">
          }
          @if (validaCompaniaInmueble(this.detalleRecuperacionPago.cve_cobertura || 0, this.detalleRecuperacionPago.estatus_tercero, this.detalleRecuperacionPago.tipo_tercero)) {
            <mat-select
              formControlName="compania">
              @for (comp of catCompanias; track comp) {
                <mat-option [value]="comp.numerok">{{comp.numerok}} - {{
                comp.nombre}}</mat-option>
              }
            </mat-select>
          }
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if (seccion == 2 && [9].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Garantía:</mat-label>
          <input matInput formControlName="subtipoPagoGarantia">
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if (seccion == 2 && [6].includes(this.formPagos.get('tipo')?.value)) {
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Tradicional tipo:</mat-label>
          <mat-select formControlName="tradicionalTipo">
            @for (tt of catConsultaTradicionalTipo; track tt) {
              <mat-option [value]="tt.valor_dato">{{
              tt.descripl_dato}}</mat-option>
            }
          </mat-select>
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if (seccion == 2 && [5, 6].includes(this.formPagos.get('tipo')?.value) && (this.formPagos.get('subTipo')?.value == 1 || this.formPagos.get('subTipo')?.value == 2)) {
      <div class="col-md-12 mt-2"
        >
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Compañía:</mat-label>
          @if (!validaCompaniaInmueble(this.detalleRecuperacionPago.cve_cobertura || 0, this.detalleRecuperacionPago.estatus_tercero, this.detalleRecuperacionPago.tipo_tercero)) {
            <input
              matInput formControlName="descripcionCompania" [UpperCase]="true">
          }
          @if (validaCompaniaInmueble(this.detalleRecuperacionPago.cve_cobertura || 0, this.detalleRecuperacionPago.estatus_tercero, this.detalleRecuperacionPago.tipo_tercero)) {
            <mat-select
              formControlName="compania">
              @for (comp of catCompanias; track comp) {
                <mat-option [value]="comp.numerok">{{comp.numerok}} - {{
                comp.nombre}}</mat-option>
              }
            </mat-select>
          }
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
    @if (catCoberturas.length && this.formPagos.get('tipo')?.value) {
      <div class="col-md-12 mt-4">Datos para Generación de ingresos referenciados:</div>
      <div class="col-md-4">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Cobertura:</mat-label>
          <mat-select formControlName="coberturaIngreso">
            <mat-option [value]="0">SELECCIONE</mat-option>
            @for (cob of catCoberturas; track cob) {
              <mat-option [value]="cob.valor_dato">{{ cob.descripc_dato
              }}</mat-option>
            }
          </mat-select>
          <mat-error>Campo obligatorio</mat-error>
        </mat-form-field>
      </div>
    }
  </form>
}

@if (habilitaAsegurado) {
  <div class="row m-0 p-1 justify-content-end">
    <div class="col-md-auto d-flex justify-content-end">
      <button color="accent" mat-raised-button type="button" (click)="regresaConsulta()" [disabled]="false">
        Regresar
      </button>
    </div>
    <div class="col-md-auto d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="validaGuardaActualizaRecuperacionPago()"
        [disabled]="false">
        Guardar
      </button>
    </div>
  </div>
}